class Controller {
  constructor(Events, $stateParams, Sections) {
    "ngInject";

    this.Events = Events;
    this.$stateParams = $stateParams;

    this.sections = Sections.fleetSections;
    this.activeParams = this.$stateParams;

    this.addItemEvent = this.Events.getAddEvent("companies");
    this.filterEvent = this.Events.getFilterEvent("companies");
    this.paginateEvent = this.Events.getPaginateEvent("companies");
    this.sortEvent = this.Events.getSortEvent("companies");
  }

  /**
   * @param {{ owner: Object; owner_name: Object; owner_phone_data: String; email?: String; }} model
   */
  addItemCustomizeOptions(model) {
    const { owner_name: ownerName, owner_phone_data: phoneData, email } = model;
    model.owner = {
      name_i18n: ownerName,
      phone_data: phoneData,
      email,
    };
    delete model.owner_name;
    delete model.owner_phone_data;
    delete model.email;
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/companies/companies.controller.js